// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._170i8ru0 {\n  overflow: hidden;\n  position: relative;\n  padding: 0 0 50px;\n}\n._170i8ru1 {\n  width: 100%;\n  max-width: 100vw;\n}\n._170i8ru2 {\n  width: 100%;\n  max-width: min(551px, 100vw);\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
